import PropTypes from 'prop-types';
import { Box, Typography, Avatar, Chip } from '@mui/material';
import { CloudUploadOutlined, CheckCircleOutlined } from '@mui/icons-material';

const UploadField = ({ label, preview, fileName, onChange, required }) => (
    <Box>
        <Typography variant="caption" sx={{ color: 'text.secondary', mb: 0.5, display: 'block', fontWeight: 600 }}>
            {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
        </Typography>
        <Box
            component="label"
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                p: 2,
                border: '2px dashed',
                borderColor: preview ? 'primary.main' : 'divider',
                borderRadius: 2,
                cursor: 'pointer',
                transition: 'all 0.2s',
                bgcolor: preview ? 'primary.50' : 'background.paper',
                '&:hover': { borderColor: 'primary.main', bgcolor: 'primary.50' }
            }}
        >
            <input type="file" hidden accept="image/*,application/pdf" onChange={(e) => onChange && onChange(e)} />
            {preview ? (
                <>
                    {preview.startsWith('data:application/pdf') ? (
                        <Box
                            sx={{
                                width: 56,
                                height: 56,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                bgcolor: 'error.50',
                                borderRadius: 1.5,
                                border: '2px solid',
                                borderColor: 'error.main',
                                flexShrink: 0
                            }}
                        >
                            <Typography variant="caption" color="error" fontWeight="bold">
                                PDF
                            </Typography>
                        </Box>
                    ) : (
                        <Avatar
                            src={preview}
                            variant="rounded"
                            sx={{ width: 56, height: 56, border: '2px solid', borderColor: 'primary.main' }}
                        />
                    )}
                    <Box flex={1} sx={{ overflow: 'hidden' }}>
                        <Typography variant="body2" color="primary" fontWeight={600} noWrap>
                            {fileName || 'Image Selected'}
                        </Typography>
                        <Chip label="Change photo" size="small" variant="outlined" sx={{ mt: 0.5 }} />
                    </Box>
                    <CheckCircleOutlined sx={{ color: 'success.main', flexShrink: 0 }} />
                </>
            ) : (
                <>
                    <Box
                        sx={{
                            width: 56,
                            height: 56,
                            borderRadius: 2,
                            bgcolor: 'grey.100',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <CloudUploadOutlined sx={{ color: 'primary.main', fontSize: 28 }} />
                    </Box>
                    <Box>
                        <Typography variant="body2" fontWeight={600}>
                            Click to upload
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            PNG, JPG, PDF up to 1MB
                        </Typography>
                    </Box>
                </>
            )}
        </Box>
    </Box>
);

UploadField.propTypes = {
    label: PropTypes.string.isRequired,
    preview: PropTypes.string,
    fileName: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool
};

UploadField.defaultProps = {
    preview: null,
    required: false
};

export default UploadField;
